import { render, staticRenderFns } from "./home-research.vue?vue&type=template&id=3b66ac99&scoped=true&"
import script from "./home-research.vue?vue&type=script&lang=js&"
export * from "./home-research.vue?vue&type=script&lang=js&"
import style0 from "./home-research.vue?vue&type=style&index=0&id=3b66ac99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66ac99",
  null
  
)

export default component.exports